import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AnalyticsService } from '../../services/analytics.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-email-purchase',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatRippleModule,
    MatButtonModule,
    CommonModule,
  ],
  templateUrl: './email-purchase.component.html',
  styleUrl: './email-purchase.component.scss',
})
export class EmailPurchaseComponent implements OnInit {
  userEmail: string = '';

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private analyticsService: AnalyticsService // Inject AnalyticsService
  ) {}

  ngOnInit() {
    // Fire Google Analytics event immediately when the component mounts
    this.route.queryParams.subscribe((params) => {
      this.userEmail = params['email'] || '';

      this.analyticsService.trackEvent(
        'purchase_completed', // Event Name
        'Purchase via Email', // Event Label
        'Purchase', // Event Category
        `User completed purchase via email` // Event Description (optional, no email for privacy)
      );

      console.log('Purchase completed event fired');
    });
  }

  goToLogin() {
    this.router.navigate(['login']);
  }
}
